<div class="status-badge" [ngClass]="statusBadgeClass">{{ statusDisplay }}</div>
